/* eslint-env browser */
import { signServiceProviderAgreements } from '../../adAgreement/common/service-provider-management-gateway/serviceProviderManagementService';

const getPactsafe = () => {
  // eslint-disable-next-line no-underscore-dangle
  const ps = process.env.IS_BROWSER && window._ps;
  if (!ps) {
    throw new Error('Pactsafe global "_ps" is not available. Did you forget to load it?');
  }
  return ps;
};
export const getPactsafeLoadSnippet = (pactsafeAccessId, groupKey) => {
  const debug = process.env.NODE_ENV === 'development';
  return `(function(w,d,s,c,n,a,b){w['PactSafeObject']=n;w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)}, w[n].on=function(){(w[n].e=w[n].e||[]).push(arguments)},w[n].once=function(){(w[n].eo=w[n].eo||[]).push(arguments)},w[n].off=function(){(w[n].o=w[n].o||[]).push(arguments)},w[n].t=1*new Date(); a=d.createElement(s),b=d.getElementsByTagName(s)[0];a.async=1;a.src=c;b.parentNode.insertBefore(a,b) })(window,document,'script','//vault.pactsafe.io/ps.min.js','_ps');
    _ps('create', '${pactsafeAccessId}', { disable_sending: true, test_mode: ${debug} });
    _ps('load', '${groupKey}');
    _ps.debug = ${debug};`;
};
/**
 * sendAgreed
 * @param  {String} groupKey Pactsafe group key
 * @param  {String} userId User ID
 * @param  {Function} [ps=getPactsafe()] only used for testing
 * @param  {Object} [customData] customData is optional. Special Pactsafe properties that can be
 * used are 'email', 'first_name', and 'last_name'
 * @return {Promise} promise
 */
export const sendAgreed = ({
  groupKey, userId, ps = getPactsafe(), /** optional custom data * */ customData,
}) =>
  new Promise((resolve, reject) => {
    ps(`${groupKey}:send`, 'agreed', {
      signer_id: userId,
      custom_data: customData,
      disable_sending: false,
      event_callback: e => (e ? reject(new Error(e)) : resolve(true)),
    });
  });

/**
 * sendAdsAgreed
 * @param  {String} groupKey Pactsafe group key
 * @param  {String} serviceProviderId New signer identifier
 * @return {Promise} promise
 */
export const sendAdsAgreed = ({
  groupKey,
  serviceProviderId,
}) =>
  new Promise((resolve, reject) => {
    const environment = process.env.NODE_ENV || 'test';

    signServiceProviderAgreements(serviceProviderId, groupKey, 'Business Center(office-app)', environment)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          resolve(true);
        } else {
          reject(new Error(`Request failed with status code ${response.status}`)); // Reject with error message
        }
      })
      .catch((error) => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/modules/legal/common/pactsafe.js